export interface RepsResponse {
  status: 'success';
  allowed: boolean;
  assigned_rep: {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    image_status: string;
    territory_details: string;
    image: string | null;
    calendar_link: string | null;
  };
  assignable_reps_count: number;
  assignable_reps: Array<{
    id: string;
    status: string;
    type: string;
    manufacturer_id: string;
    manufacturer_name: string;
    position: string;
    url_key: string | null;
    name: string | null;
    email: string;
    region: string | null;
    telephone: string | null;
    fax: string | null;
    country_id: string | null;
    image_status: string;
    image: string | null;
    shown_country_id: string;
    shown_region_id: string;
    created_at: string;
    notes: string | null;
    first_name: string;
    last_name: string;
    direct_telephone: string;
    territory_details: string;
    job_title: string | null;
    about_me: string | null;
    about_me_status: string;
    show_in_directory: string;
    company_name: string | null;
    profile_video: string | null;
    mobile_phone: string | null;
    order_status: string | null;
    primary_area_spec: string | null;
    secondary_area_spec: string | null;
    certification: string | null;
    number_of_projects: string | null;
    language_spoken: string | null;
    territory_states: string | null;
    calendar_link: string | null;
    customer_entity_id: string;
    customer_firstname: string;
    customer_lastname: string;
    customer_group_id: string;
    customer_is_active: string;
    customer_default_billing: string;
    customer_default_shipping: string;
    is_registered_user: string;
    user_image: string | null;
  }>;
}

/**
 * Fetches assigned representatives for a specific product.
 *
 * @param bearerToken A string for the authorization token, if provided.
 * @param productId An optional string representing the product ID.
 * @returns A promise that resolves to a `RepsResponse` object containing the assigned reps data if the product ID and token are provided.
 * @throws An error if the fetch request fails, the response is not OK, or an unexpected error occurs.
 */
export const fetchReps = async (
  bearerToken: string | null,
  productId?: string,
): Promise<RepsResponse> => {
  try {
    if (productId && bearerToken) {
      const response = await fetch(
        // @ts-expect-error
        `${BASE_URL}/reps/assigned/index?product_id=${productId}`,
        {
          method: 'GET',
          headers: {
            Authorization: bearerToken,
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      return data;
    }

    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {} as any;
  } catch (error) {
    console.error('Error fetching reps:', error);
    throw error;
  }
};
